import Axios from "axios";

export const api = Axios.create({
	baseURL: "http://54.90.147.190:9000/",
	maxRedirects: 0,
});